<div class="modal" [ngStyle]="{display: cookiePolicyModal ? 'flex' : null}">
  <div class="modal-body">
    <div class="container">
      <div class="left">
        <h5 class="title">Your privacy is important to us</h5>
        <p class="description">This website uses own cookies and third party cookies, to improve your user's experience,
          collect statistics to optimize site functionality, and deliver content tailored to your interests.
          <a routerLink="/privacy-policy" (click)="goToPrivacyPolicy()">Learn more</a>
        </p>
      </div>
      <div class="right d-flex align-items-center">
        <a class="btn btn-outline-primary mr-2" (click)="rejectCookie()">
          Decline <span class="icon end"></span>
        </a>
        <a class="btn btn-primary" (click)="acceptCookie()">
          Accept <span class="icon end"></span>
        </a>
      </div>
    </div>
  </div>
</div>